import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Card, Text } from '@rneui/themed';
import { ProductType } from '@annunciate/core';
import { useOnPurchaseHandler } from '@annunciate/ui/dist/hooks/purchase/useOnPurchaseHandler';
import { getRecurranceLabelFromPeriod, getLabelFromProductType, } from '../../utils/purchase';
import { RenderHtml, DescriptionMask } from '../shared';
export const PurchaseableCard = ({ purchaseable, descriptionMaxHeight, }) => {
    const onPurchase = useOnPurchaseHandler();
    const label = getLabelFromProductType(purchaseable.productType);
    const recurrance = getRecurranceLabelFromPeriod(purchaseable.period);
    const isRental = purchaseable.productType === ProductType.RENTAL;
    const delimiter = isRental ? 'for' : 'per';
    return (React.createElement(Card, { key: purchaseable.id, containerStyle: { marginVertical: 0 } },
        React.createElement(Card.Title, null, purchaseable.title),
        React.createElement(Card.Divider, null),
        React.createElement(DescriptionMask, { maxHeight: descriptionMaxHeight },
            React.createElement(RenderHtml, { html: purchaseable.description || '', contentWidth: 10 })),
        purchaseable.price ? (React.createElement(React.Fragment, null,
            React.createElement(View, { style: style.price },
                React.createElement(View, null,
                    React.createElement(Text, { h1: true }, purchaseable.price)),
                recurrance && React.createElement(View, { style: style.recurrance },
                    React.createElement(Text, { style: style.recurranceText }, delimiter),
                    React.createElement(Text, { style: style.recurranceText }, recurrance))))) : null,
        React.createElement(Button, { buttonStyle: style.buttonStyle, style: style.buttonContainerStyle, onPress: () => onPurchase(purchaseable) }, `${label}${isRental && !purchaseable.price ? ` ${delimiter} ${recurrance} ` : ''}`)));
};
const style = StyleSheet.create({
    buttonStyle: {
        flex: undefined,
        minWidth: 150,
    },
    buttonContainerStyle: {
        marginTop: 20,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    price: {
        width: '100%',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        marginTop: 10,
        textAlign: 'center',
    },
    recurrance: {
        paddingLeft: 7,
    },
    recurranceText: {
        fontSize: 14,
    },
});
//# sourceMappingURL=PurchaseableCard.js.map